var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 68,
    viewBox: "0 0 55 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10609_17520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7415 17.0246L36.0008 54.6237L28.7921 67.8487L28.4056 12.1273L35.7415 17.0246Z",
    fill: "#1C385F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0978 35.5633L45.7778 21.4402L28.3907 9.82194L28.3234 -9.15527e-05L54.9638 19.8311L38.2026 50.6693L38.0978 35.5633Z",
    fill: "#1C385F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1829 17.1394L19.4447 54.7385L26.8354 67.8637L26.4489 12.1423L19.1829 17.1394Z",
    fill: "#1C385F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0834 35.7108L9.20893 21.6925L26.4339 9.83473L26.3641 0.0126953L0.000488281 20.2131L17.1881 50.8143L17.0834 35.7108Z",
    fill: "#1C385F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10609_17520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.9639,
    height: 67.8636,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.924aec132b62a952e3c9c4574ab41cbf.svg";
export { ForwardRef as ReactComponent };